import React from 'react';
import { Box, Drawer, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import * as uiActions from 'modules/UI/actions';
import Login from './components/Login';
import Register from './components/Register';
import { AuthPopupEnum } from 'utils/constants';

const AuthDrawer = () => {
  const showAuthPopup = useSelector((state) => state.ui.showAuthPopup);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(uiActions.hideLogin());
  };

  const handleOpenLogin = () => {
    dispatch(uiActions.showLogin()); 
  };

  return (
    <Drawer
      anchor="right"
      open={Boolean(showAuthPopup)}
      onClose={handleClose}
      transitionDuration={300}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 450 },
          transition: 'transform 300ms ease-in-out !important',
          transform: Boolean(showAuthPopup) ? 'translateX(0)' : 'translateX(100%)',
          boxSizing: 'border-box',
        },
      }}
    >
      <Box
        sx={{ 
          width: '100%',
          p: { xs: 2, sm: 3 },
          boxSizing: 'border-box'
        }}
        role="presentation"
      >
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {showAuthPopup === AuthPopupEnum.login ? 
          <Login /> : 
          <Register onClose={handleClose} onOpenLogin={handleOpenLogin} />
        }
      </Box>
    </Drawer>
  );
};

export default AuthDrawer;